// import { jwtDecode } from "jwt-decode";
import { jwtDecode } from "jwt-decode";
import API from "../API";
import Access from "./Access";

var Authentication = {
    async login(data) {
        var result = await API.process(
            'Authentication/authenticate',
            'POST',
            data
        ).catch((err) => {
            throw err;
        })

        const token = result.token;
        localStorage.setItem('token', token);
        // Default to client-side 30 minute timers after a fresh login
        localStorage.setItem('useServerExpiry', 'false');
        result = await API.process(
            'api/users/roles',
            'GET',
            null
        ).catch((err) => {
            throw err;
        })
        localStorage.setItem('fr', JSON.stringify(result));


        // if has admin or has facilities facility screen
        window.location = '/facilities';
        // If patient only go to main screen
        return result
    }, async onboardUser(User) {

        try {
            const res = await API.process(
                `Authentication/onboardUser/${User.userId}`,
                'POST',
                User
            )
            if (res && res.exists) {
                window.location = '/logout?exists=true';
            }
            console.log('this.loginByUserId', res)
            //await this.loginByUserId({
            //    ...User,
            //    userId: res.id
            //})
            await this.login(res)
        } catch (e) {
            console.error('onboardUser', e)
            throw e
        }
    }, async loginByUserId(User, ShareID, goto) {

        var result = await API.process(
            `Authentication/authenticateById/${User.userId}`,
            'POST',
            User
        ).catch((err) => {
            throw err;
        })

        // localStorage.setItem('CachedResources', JSON.stringify(await Access.GetAvailableResourcesByUserID(User.userId)))
        if (ShareID)
            localStorage.setItem('ShareID', ShareID);
        const token = result.token;
        localStorage.setItem('token', token);
        // Default to client-side 30 minute timers after a fresh login
        localStorage.setItem('useServerExpiry', 'false');
        var result = await API.process(
            'api/users/roles',
            'GET',
            null
        ).catch((err) => {
            throw err;
        })
        localStorage.setItem('fr', JSON.stringify(result));
        // if has admin or has facilities facility screen
        window.location = `/facilities${goto ? `?goto=${goto}` : ''}`;
        // If patient only go to main screen
        return result
    },
    async reloadFacilities() {
        var result = await API.process(
            'api/users/roles',
            'GET',
            null
        ).catch((err) => {
            throw err;
        })
        localStorage.setItem('fr', JSON.stringify(result));
        return result
    },
    async token() {
        return localStorage.getItem('token');
    },
    async refresh() {
        if (jwtDecode(localStorage.getItem('token')).exp * 1000 > Date.now())
            return jwtDecode(localStorage.getItem('token')).sub;
    },
    async refreshToken(token) {
        // Called when a refreshed token is received from the server via API response header
        localStorage.setItem('token', token);
        // When we receive a server token, switch to using server-issued expiry so client timers align
        localStorage.setItem('useServerExpiry', 'true');
    },
    async logout() {
        localStorage.removeItem('AcceptedTNC')
        await API.process(
            'Authentication/logout',
            'POST',
            {
                token: localStorage.getItem('token')
            }
        ).catch((err) => {
            // throw err;
        }).then((r) => {
            try {
                localStorage.removeItem('token');
                localStorage.removeItem('facility')
                localStorage.removeItem('fr')
                localStorage.removeItem('patient')
                localStorage.removeItem('ShareID');
                localStorage.removeItem('CachedResources');
                localStorage.removeItem('useServerExpiry');
            } catch (e) {

            }
        })
    },
    async facilities() {
        try {
            // const user = jwtDecode(localStorage.getItem('token'));
            // return JSON.parse(user.faclities)
            return JSON.parse(localStorage.getItem("fr"))
        } catch (e) {
            if (e.message === "Invalid token specified") {
                if (!Authentication.verifyToken(e.message)) return []
                // return (window.location.href.indexOf('/logout') === -1) ? window.location = '/expired' : undefined;
            }

        }
    },
    facilitiesCnt() {
        try {
            const user = jwtDecode(localStorage.getItem('token'));
            // return JSON.parse(user.faclities).length
            return JSON.parse(localStorage.getItem("fr")).length
        } catch (e) {
            if (e.message === "Invalid token specified") {
                if (!Authentication.verifyToken(e.message)) return 0
                // return (!window.location.href.indexOf('/logout')) ? window.location = '/logout' : undefined;
                return 0
            }
        }
    },
    isClaimValid(claim) {
        var roles = {};
        // if (!localStorage.getItem('token') || localStorage.getItem('token') === "") {
        //     return (!window.location.href.indexOf('/logout')) ? window.location = '/logout' : undefined;
        // }
        if (!Authentication.verifyToken()) return roles

        try {
            roles = JSON.parse(localStorage.getItem("fr"))
            if (!roles) return window.location = '/logout'

            // Check if user is System Admin - they have all permissions
            const isSystemAdmin = roles.find(r => r.roles.role === "System Admin");
            if (isSystemAdmin) return true;

            if (claim === "System Admin")
                return false; // Already checked above, user doesn't have it

            let facilityId = parseInt(localStorage.getItem('facility'));
            let faclities = JSON.parse(localStorage.getItem("fr"))

            if (faclities.filter(a => a.facility.id === facilityId).find(x => x.roles.role === 'Super'))
                return true
            return faclities.filter(a => a.facility.id === facilityId).find(x => x.roles.role === claim) !== undefined

        } catch (e) {
            if (e.message === "Invalid token specified") {
                // if (
                //     window.location.href.indexOf('/logout') === -1 ||
                //     window.location.href.indexOf('/expired') === -1
                // ) window.location.replace('/expired')
                if (!Authentication.verifyToken(e.message)) return false
                return false
            }
            // return (!window.location.href.indexOf('/logout')) ? window.location = '/logout' : undefined;
        }
        return false;
        // try{
        // return (roles.find(r => r.Role === claim));
        // Check expired
        // Read Token
        // Get Claims
        // Check claim in list
        // return true;
    },
    async setFacility(id, roleId) {
        localStorage.setItem('facility', id)
        localStorage.setItem('role', roleId)
        if (
            String(jwtDecode(localStorage.getItem('token')).tnc) === "false" &&
            (!localStorage.getItem('AcceptedTNC') || localStorage.getItem('AcceptedTNC') !== 'true')
        ) {
            window.location = '/atnc'
            return false
        }
        var AccessLevel = localStorage.getItem('ShareID') != null ? "SHARE" : "SYSTEM"
        console.log(await Access.GetAvailableResourcesByUserID(Authentication.UserId(), id, AccessLevel))
        localStorage.setItem('CachedResources', JSON.stringify(await Access.GetAvailableResourcesByUserID(Authentication.UserId(), id, AccessLevel)))
        return true
        // alert(String(jwtDecode(localStorage.getItem('token')).tnc))
        // return window.location = '/atnc'

    },
    getFacilityName() {
        if (!Authentication.verifyToken()) return ""
        if (localStorage.getItem('token')) {
            const user = jwtDecode(localStorage.getItem('token'));
            if (localStorage.getItem("fr")) {
                const facilities = JSON.parse(localStorage.getItem("fr"))
                for (var facility of facilities)
                    if (facility.facility.id === parseInt(localStorage.getItem('facility')))
                        return facility.facility.facility
            }
        }
        return ''
    },
    getFacilityDetails() {
        if (!Authentication.verifyToken()) return ""
        if (localStorage.getItem('token')) {
            if (localStorage.getItem("fr")) {
                const facilities = JSON.parse(localStorage.getItem("fr"))
                for (var facility of facilities)
                    if (facility.facility.id === parseInt(localStorage.getItem('facility')))
                        return facility.facility
            }
        }
        return ''
    },
    getFacility() {
        if (!Authentication.verifyToken()) return ""
        return localStorage.getItem('facility')
    },
    getShareID() {
        const id = localStorage.getItem('ShareID')
        // console.log('getShareID', id !== null ? id : undefined)
        return id !== null ? id : false
    },
    getFacilityRole() {
        return undefined
        // var roles = {};
        // if (!localStorage.getItem('token') || localStorage.getItem('token') === "") {
        //     return (!window.location.href.indexOf('/logout')) ? window.location = '/logout' : undefined;
        // }
        // try {
        //     let facilityId = localStorage.getItem('facility');
        //     let roleId = localStorage.getItem('role');
        //     let faclities = JSON.parse(localStorage.getItem('fr'))
        //     for (var i = 0; i < faclities.length; i++) {
        //         if (faclities[i].facility.id === parseInt(facilityId) && faclities[i].roles.id === parseInt(roleId))
        //             return faclities[i].roles.role;
        //     }
        // } catch (e) {
        //     if (e.message === "Invalid token specified")
        //         return (!window.location.href.indexOf('/logout')) ? window.location = '/logout' : undefined;
        // }
        // return (!window.location.href.indexOf('/logout')) ? 'logout' : undefined;
    },
    getFacilityRoles() {
        var roles = {};

        if (!Authentication.verifyToken(undefined)) return []
        // return []

        try {
            let facilityId = parseInt(localStorage.getItem('facility'));
            let roleId = localStorage.getItem('role');
            let faclities = JSON.parse(localStorage.getItem('fr'))
            if (facilityId === -1 && faclities[0].roles.role === 'System Admin')
                return ['System Admin']
            return faclities.filter(a => a.facility.id === facilityId).map(a => a.roles.role)
        } catch (e) {
            if (e.message === "Invalid token specified")
                return (!window.location.href.indexOf('/logout')) ? window.location = '/logout' : undefined;
        }
    },
    UserId(ignoreRedirect) {

        var roles = {};
        if ((!localStorage.getItem('token') || localStorage.getItem('token') === "") && !ignoreRedirect) {
            return (!window.location.href.indexOf('/logout')) ? window.location = '/logout' : undefined;
        }
        try {
            const user = jwtDecode(localStorage.getItem('token'));
            return user.id
            // let facilityId = localStorage.getItem('facility');
            // let faclities = JSON.parse(user.faclities)
            // for (var i = 0; i < faclities.length; i++) {
            //     if (faclities[i].Facility.Id === parseInt(facilityId)) {
            //         return faclities[i].Roles.Role;
            //     }
            // }
            // roles = JSON.parse(user.roles)
        } catch (e) {
            if (e.message === "Invalid token specified" && !ignoreRedirect)
                return (!window.location.href.indexOf('/logout')) ? window.location = '/logout' : undefined;
        }
        return (!window.location.href.indexOf('/logout')) ? 'logout' : undefined;
    },
    PID() {


        try {
            const user = jwtDecode(localStorage.getItem('token'));
            try {
                return JSON.parse(user.pid)
            } catch (e) {
                return;
            }
            // let facilityId = localStorage.getItem('facility');
            // let faclities = JSON.parse(user.faclities)
            // for (var i = 0; i < faclities.length; i++) {
            //     if (faclities[i].Facility.Id === parseInt(facilityId)) {
            //         return faclities[i].Roles.Role;
            //     }
            // }
            // roles = JSON.parse(user.roles)
        } catch (e) {

        }

    },
    UserName() {
        // if (!localStorage.getItem('token') || localStorage.getItem('token') === "") {
        //     return window.location = '/logout';
        // }
        try {
            const user = jwtDecode(localStorage.getItem('token'));
            return user.name
        } catch (e) {
            // if (e.message === "Invalid token specified")
            //     return (!window.location.href.indexOf('/logout')) ? window.location = '/logout' : undefined;
        }
        return null
        // return (!window.location.href.indexOf('/logout')) ? 'logout' : undefined;
    },
    UserProfile() {
        // if (!localStorage.getItem('token') || localStorage.getItem('token') === "") {
        //     return window.location = '/logout';
        // }
        try {
            const user = jwtDecode(localStorage.getItem('token'));
            return user
        } catch (e) {
            // if (e.message === "Invalid token specified")
            //     return (!window.location.href.indexOf('/logout')) ? window.location = '/logout' : undefined;
        }
        return null
        // return (!window.location.href.indexOf('/logout')) ? 'logout' : undefined;
    },
    setActivePatient(patientId) {
        localStorage.setItem('patient', patientId)
    },
    clearActivePatient() {
        localStorage.removeItem('patient')
    },
    getActivePatient() {
        return localStorage.getItem('patient')
    },
    getTimeOut() {
        // By default use a client-side 30 minute timeout after login.
        // If we have explicitly received a refreshed server token, use the server JWT expiry to synchronize timers.
        try {
            const tok = localStorage.getItem('token')
            const useServer = localStorage.getItem('useServerExpiry') === 'true'
            if (tok && useServer) {
                const decoded = jwtDecode(tok)
                if (decoded && decoded.exp) {
                    return decoded.exp * 1000 // exp is in seconds, convert to ms
                }
            }
        } catch (e) {
            // ignore and fallback
        }
        // fallback: 30 minutes from now
        return localStorage.getItem('token') ? Date.now() + (30 * 60 * 1000) : -1
    },
    verifyToken(error) {
        if (error && error === "Invalid token specified") {
            const location = window.location.href
            // if (
            //     location.indexOf('/share') === -1 &&
            //     location.indexOf('/logout') === -1 &&
            //     location.indexOf('/reset') === -1 &&
            //     location.indexOf('/expired') === -1
            // ) window.location.replace('/expired')
            return false
        }
        if (!localStorage.getItem('token') || localStorage.getItem('token') === "") {
            const location = window.location.href
            // if (
            //     location.indexOf('/share') === -1 &&
            //     location.indexOf('/logout') === -1 &&
            //     location.indexOf('/reset') === -1 &&
            //     location.indexOf('/expired') === -1
            // )
            //     window.location.replace('/expired')
            return false
        }
        if (localStorage.getItem('token') && jwtDecode(localStorage.getItem('token')).exp * 1000 < Date.now()) // Expired
        {
            if (window.location.pathname !== "/logout") {
                localStorage.removeItem('token');
                localStorage.removeItem('facility')
                localStorage.removeItem('role')
                localStorage.removeItem('patient')
                try { localStorage.removeItem('ShareID'); } catch (e) { console.warn('Not a shared session') }
                try { localStorage.removeItem('CachedResources'); } catch (e) { console.warn('Not a shared session') }
                // if (
                //     window.location.href.indexOf('/share') === -1 &&
                //     window.location.href.indexOf('/logout') === -1 &&
                //     window.location.href.indexOf('/reset') === -1 &&
                //     window.location.href.indexOf('/expired') === -1
                // ) window.location.replace('/expired')
            }
        }
        return true
    },
    async logoutFacility() {

        if (localStorage.getItem('token')) // Expired
        {
            localStorage.removeItem('facility')
            localStorage.removeItem('role')
            localStorage.removeItem('patient')
            try { localStorage.removeItem('CachedResources'); } catch (e) { console.warn('Not a shared session') }
        }
    },
    async ResetPasswordRequest(username) {

        var result = await API.process(
            'Authentication/password',
            'PUT',
            // undefined
            { token: username }
        ).catch((err) => {
            throw err;
        })


        return result
    },
    async ResetPasswordTempRequest(details) {

        var result = await API.process(
            'Authentication/temp/password',
            'PUT',
            // undefined
            details
        ).catch((err) => {
            throw err;
        })


        return result
    },
    async DoResetPassword(req) {

        var result = await API.process(
            `Authentication/password`,
            'PATCH',
            req
        ).catch((err) => {
            throw err;
        })


        return result
    },
    async AcceptTnC() {

        localStorage.setItem('AcceptedTNC', true)
        var result = await API.process(
            `Authentication/AcceptTnC/${Authentication.UserId()}`,
            'PUT',
            null
        ).catch((err) => {
            throw err;
        })


        return result
    },
    LoopResource(resource, resources) {
        // console.log('LoopResource', resource, resources)
        // resource = [{ resource: "Messages", type: 'View' }, { resource: "Messages", type: 'Edit' }]
        // [{"accessTypes":
        //     ["Inherit","Inherit"],
        //     "resource":
        //     {"human":"Messages",
        //         "resource":"Messages",
        //         "resources":[{
        //             "accessTypes":["View","View"],
        //             "resource":{"human":"Your Messages",
        //                 "resource":"Messages|Own","resources":[]}},
        //                 {"accessTypes":["View","View"],"resource":{"human":"Patient Linked Messages","resource":"Messages|Patient","resources":[]}}]}},

        // var resources = res.resource.split("|");
        var valid = true
        // console.log('LoopResource', resources)
        // for (var a = 0; a < resources.length; a++) {
        const hasAccessTo = resources
        // console.log('LoopResource',)
        // console.log('LoopResource', Object.keys(hasAccessTo).includes('resource'))
        // console.log('LoopResource', resources)
        if (Object.keys(hasAccessTo).includes('resource')) {
            const hasAccessToResource = hasAccessTo.resource // human | resource
            const hasAccessToResourceSplit = hasAccessToResource.resource.split("|")

            for (var b = 0; b < resource.length; b++) {
                const needsResource = resource[b]
                const needsResourceSplit = needsResource.resource.split("|")


                // console.log('LoopResource', needsResourceSplit,)
                for (var i = 0; i < hasAccessToResourceSplit.length; i++) {
                    // console.log('XXXXXXXX', resources_cons[i])
                    // console.log('LoopResource', hasAccessToResourceSplit[i], needsResourceSplit[i])
                    // Not inherited
                    // if (hasAccessToResourceSplit.Length === i || typeof hasAccessToResourceSplit[i] === 'undefined')
                    // Inheritance
                    if (needsResourceSplit.Length === i || typeof needsResourceSplit[i] === 'undefined')
                        break;
                    if (hasAccessToResourceSplit[i] !== needsResourceSplit[i]) {
                        valid = false;
                    }
                }
                if (valid) {
                    // console.log('LoopResource :: Has Resource', hasAccessToResource.resource)
                    const hasAccessTypes = hasAccessTo.accessTypes
                    // console.log('XXXXXXXX VALID', c.accessTypes, res.resource)
                    for (var t1 = 0; t1 < hasAccessTypes.length; t1++) {
                        var hasAccessType = hasAccessTypes[t1]
                        // console.log('LoopResource', hasAccessType)
                        // console.log('LoopResource', hasAccessType, needsResource.type)
                        if (hasAccessType === needsResource.type) {
                            // console.log('LoopResource', hasAccessType, hasAccessTo, hasAccessToResourceSplit, needsResourceSplit)
                            // console.log('XXXXXXXX VALID 1', c.accessTypes, t)
                            // console.log('LoopResource :: Has Resource')
                            return true
                        }
                    }
                }
            }




            if (Object.keys(hasAccessTo.resource).includes('resources')) {
                // console.log('LoopResource', hasAccessTo.resource.resources)
                for (var r = 0; r < hasAccessTo.resource.resources.length; r++) {
                    // console.log('LoopResource', hasAccessTo.resource.resources[r])
                    if (Authentication.LoopResource(resource, hasAccessTo.resource.resources[r])) {
                        // console.log('LoopResource :: Has Resource ')
                        return true
                    }
                }
            }

            return false
        }
        // }


        // for (var a = 0; a < dec.length; a++) {
        //     const hasAccessTo = dec[a]
        //     if (hasAccessTo.Object.keys.includes('resource')) {
        //         const hasAccessToResource = hasAccessTo.resource

        //         if (hasAccessTo.Object.keys.includes('resources')) {
        //             const resResources = Authentication.LoopResource(hasAccessTo.resources)
        //         }
        //     }
        // }

        // if (dec.accessTypes && dec.accessTypes.length > 0)
        //     for (var a = 0; a < dec.accessTypes.length; a++) {
        //         const access_type = dec.accessTypes[a]
        //         if (access_type.resource) {

        //         }
        //     }

    },
    hasResource(resource) {
        var dec = JSON.parse(localStorage.getItem("CachedResources"))
        if (!dec) return true
        // console.log('hasResource', resource, dec)

        for (var a = 0; a < dec.length; a++) {
            if (Authentication.LoopResource(resource, dec[a]))
                return true
        }

        // for (var z = 0; z < resource.length; z++) {
        //     var res = resource[z]
        //     // res.resource
        //     // res.type
        //     if (res.resource) {
        //         var resources = res.resource.split("|");

        //         for (var c1 = 0; c1 < dec.length; c1++) {
        //             var c = dec[c1]
        //             if (!c.resource) continue
        //             const resources_cons = c.resource.resource.split("|");
        //             var valid = true;
        //             // console.log('XXXXXXXX', resources)
        //             for (var i = 0; i < resources.length; i++) {
        //                 // console.log('XXXXXXXX', resources_cons[i])
        //                 if (resources_cons.Length === i || typeof resources_cons[i] === 'undefined')
        //                     break;

        //                 if (resources_cons[i] !== resources[i]) {
        //                     valid = false;
        //                 }
        //             }
        //             if (valid) {
        //                 // console.log('XXXXXXXX VALID', c.accessTypes, res.resource)
        //                 for (var t1 = 0; t1 < c.accessTypes.length; t1++) {
        //                     var t = c.accessTypes[t1]
        //                     // console.log('XXXXXXXX VALID', c.accessTypes, t)
        //                     if (t === res.type) {
        //                         // console.log('XXXXXXXX VALID 1', c.accessTypes, t)
        //                         return true
        //                     }
        //                 }
        //             }
        //         }
        //     }
        // }
        // return false
    },
}

export default Authentication;